<template>
  <div class="rb-ob-form rb-match-page rb-book-page rb-pay-page rb-consent-page">
    <header><h1 class="rb-ob-title">{{ $t('intake.boundary01Title') }}</h1></header>
    <p class="rb-consent-reassure">{{ $t('intake.boundary01Reassure') }}</p>
    <p class="rb-ob-privacy-note">
      <router-link :to="legalRoute('privacy')" target="_blank" rel="noopener">{{ $route.params.lang === 'en' ? 'Privacy notice (Persian)' : 'اطلاعیهٔ حریم خصوصی' }}</router-link>
      · <router-link :to="legalRoute('terms')" target="_blank" rel="noopener">{{ $route.params.lang === 'en' ? 'Account terms (Persian)' : 'شرایط استفاده از حساب' }}</router-link>
    </p>

    <p v-if="loading" class="rb-ob-status" role="status">{{ $t('intake.portal.loading') }}</p>
    <div v-if="!loading && template" class="rb-consent-meta">
      <span>{{ $t('intake.boundary01MetaVersion') }}: <strong>{{ template.version }}</strong></span>
    </div>
    <div v-if="!loading && template" class="rb-consent-body" tabindex="0">
      <p v-for="(para, i) in bodyParas" :key="'p'+i">{{ para }}</p>
    </div>
    <div v-else-if="!loading" class="rb-ob-status-panel">
      <p class="rb-match-outcome-body">{{ formStatus || clientMessage(blocker || 'CONSENT_TEMPLATE_NOT_APPROVED', $route.params.lang || 'fa') }}</p>
    </div>

    <label v-if="template" class="rb-consent-check" :class="{'is-selected': accepted}">
      <input v-model="accepted" type="checkbox" name="accept">
      <span>{{ $t('intake.boundary01Accept', {version: template.version}) }}</span>
    </label>

    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" :disabled="loading || !template || !accepted || submitting" @click="confirm">
        {{ submitting ? $t('intake.portal.loading') : $t('intake.boundary01Confirm') }}
      </button>
      <button v-if="!withdrawalConfirmed" class="rb-ob-submit rb-ob-submit-secondary" type="button" :disabled="loading || submitting" @click="decline">
        {{ $route.params.lang === 'en' ? 'I do not consent yet and would like guidance on the service.' : 'فعلاً رضایت نمی‌دهم و می‌خواهم دربارهٔ شرایط خدمت راهنمایی بگیرم.' }}
      </button>
      <button v-if="withdrawalFailed" class="rb-ob-submit rb-ob-submit-secondary" type="button" :disabled="loading || submitting" @click="decline">
        {{ $route.params.lang === 'en' ? 'Retry withdrawal' : 'تلاش دوباره برای پس‌گرفتن رضایت' }}
      </button>
      <router-link v-if="withdrawalConfirmed || withdrawalFailed || (!loading && !episode)" class="rb-ob-submit rb-ob-submit-secondary" :to="{name:'portalHome',params:{lang:$route.params.lang||'fa'}}">
        {{ $route.params.lang === 'en' ? 'Return to dashboard' : 'بازگشت به داشبورد' }}
      </router-link>
      <router-link v-if="withdrawalConfirmed" class="rb-ob-submit rb-ob-submit-secondary" :to="{name:'portalRequestNew',params:{lang:$route.params.lang||'fa'},query:{topic:'ACCESS'}}">{{ $route.params.lang === 'en' ? 'Ask about the service' : 'راهنمایی دربارهٔ شرایط خدمت' }}</router-link>
      <p class="rb-ob-status" role="status" aria-live="polite">{{ formStatus }}</p>
      <div class="rb-ob-trust"><p>{{ $t('intake.trustPath') }}</p><p>{{ $t('authUi.familyNote') }}</p></div>
    </div>
  </div>
</template>
<script>
import {clientMessage,clientError,isKnownClientCode} from '@/intake/clientMessages'
import {acceptCareConsent, fetchActiveCare, fetchCareConsent, withdrawCareConsent} from '@/intake/portalApi'
export default {
  name:'MatchConsentStep',
  data(){return {episode:null, consent:null, accepted:false, loading:true, submitting:false, formStatus:'', withdrawalFailed:false, withdrawalConfirmed:false, loadGeneration:0}},
  computed:{
    template(){return this.consent && this.consent.template},
    blocker(){return this.consent && (this.consent.blocker_code || this.consent.participant_authority_blocker)},
    bodyParas(){return this.template ? String(this.template.body_text || '').split(/\n+/).filter(Boolean) : []},
  },
  mounted(){this.load()},
  watch:{'$route.fullPath'(){this.load()}},
  beforeDestroy(){this.loadGeneration++},
  methods:{clientMessage,
    legalRoute(documentId){return{name:'legalDocument',params:{lang:this.$route.params.lang||'fa',documentId}}},
    load(){
      const generation=++this.loadGeneration
      this.loading=true; this.consent=null; this.episode=null; this.accepted=false; this.withdrawalFailed=false;this.withdrawalConfirmed=false
      this.formStatus=''
      return fetchActiveCare(this.$route.query || {}).then((episode)=>{
        if(generation!==this.loadGeneration)return null
        this.episode=episode
        if(!episode) throw new Error('CARE_CONTEXT_REQUIRED')
        return fetchCareConsent(episode.id)
      }).then((consent)=>{
        if(generation!==this.loadGeneration)return
        this.consent=consent; this.accepted=!!consent && consent.state==='ACCEPTED'
        if(consent && consent.state==='WITHDRAWN'){this.withdrawalConfirmed=true;this.formStatus=clientMessage('WITHDRAWN',this.$route.params.lang||'fa')}
      })
        .catch((err)=>{if(generation===this.loadGeneration)this.formStatus=clientError(err,this.$route.params.lang||'fa')})
        .finally(()=>{if(generation===this.loadGeneration)this.loading=false})
    },
    confirm(){
      if(this.submitting || !this.episode || !this.template || !this.accepted) return
      this.submitting=true; this.formStatus=''
      const generation=this.loadGeneration
      return acceptCareConsent(this.episode.id,this.template.version,this.template.content_hash)
        .then(()=>{if(generation===this.loadGeneration)return this.$router.push({name:'intakeBaseline',params:{lang:this.$route.params.lang||'fa'},query:this.$route.query})})
        .catch((err)=>{if(generation===this.loadGeneration)this.formStatus=clientError(err,this.$route.params.lang||'fa')})
        .finally(()=>{this.submitting=false})
    },
    decline(){
      if(this.submitting) return
      if(!this.episode){this.formStatus=this.$t('intake.portal.loadError');return}
      this.submitting=true; this.formStatus=''; this.withdrawalFailed=false
      const generation=this.loadGeneration
      return withdrawCareConsent(this.episode.id).then((result)=>{
        if(generation!==this.loadGeneration)return
        if(!result || result.state!=='WITHDRAWN') throw new Error('CONSENT_WITHDRAWAL_NOT_CONFIRMED')
        this.accepted=false
        this.consent={...this.consent,state:'WITHDRAWN'}
        this.withdrawalConfirmed=true
        this.formStatus=clientMessage('WITHDRAWN',this.$route.params.lang||'fa')
      }).catch((err)=>{
        if(generation!==this.loadGeneration)return
        this.withdrawalFailed=true
        const response=err && err.response && err.response.data
        const code=(response && response.data && response.data.reason_code) || (err && (err.code || err.message))
        this.formStatus=isKnownClientCode(code) ? clientError(err,this.$route.params.lang||'fa') : this.$t('intake.consentWithdrawalFailed')
      })
        .finally(()=>{this.submitting=false})
    },
  },
}
</script>
